<script setup lang="ts">
import Select from "@/components/FormInput/Select.vue";
import DateUtility from "@/ts/Utility/DateUtility";

const [model] = defineModel()
type Option = {
  value: string,
  text: string,
  disabled?: boolean
}
const currentTime = new Date();

const options: Option[] = Object.entries(DateUtility.getTimeZoneMap()).map(([offset, value]) => {
  const text = offset.replace('00','0')
  const time = currentTime.toLocaleTimeString('ru-RU', {hour: '2-digit', minute: '2-digit', timeZone: value})
  return {
    value,
    text:  `${time} (UTC ${text})`
  }
});
if (!(DateUtility.hasTimeZone(model.value as string))) {
  model.value = "Europe/Moscow";
}
</script>

<template>
  <Select :options="options" v-model="model" class="select"> </Select>
</template>

<style scoped lang="scss">
.select{
  box-sizing: border-box;
}
:deep(.select__head){
  color: #6C7BB2;
  font-weight: 700;
}
</style>
